import colors from "../../base/colors";
import borders from "../../base/borders";
import typography from "../../base/typography";
import pxToRem from "../../functions/pxToRem";

const { info, text, secondary, light } = colors;
const { borderRadius } = borders;
const { size } = typography;

export default {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: {
      minWidth: pxToRem(160),
      minHeight: "unset",
      padding: `${pxToRem(8)} ${pxToRem(16)}`,
      borderRadius: borderRadius.xs,
      fontSize: size.sm,
      color: text.main,
      fontWeight: "500",
      transition: "background-color 300ms ease, color 300ms ease",

      "&:hover, &:focus": {
        backgroundColor: secondary.main,
        color: text.main,
      },
      "&.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus": {
        backgroundColor: info.main,
        color: light.main,
      },
    },
  },
};
